import { render, staticRenderFns } from "./_delegateModal.vue?vue&type=template&id=3f8a1a09"
import script from "./_delegateModal.vue?vue&type=script&lang=js"
export * from "./_delegateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports